const t = "@perxis-auto/credit-instock", e = {
  name: t
};
export {
  e as default,
  t as name
};
